// extracted by mini-css-extract-plugin
var _1 = "useGroupMembersColumn-module__usersGrid--nG8yY";
export { _1 as "usersGrid" }
